import { Component, Inject, Input, OnInit } from '@angular/core';
import { LineItemInterface } from '../../../../../_generated/api_interfaces/api/lineItem.interface';
import { ApiServiceInterface, CrudComponent, CrudTableComponentInterface, FormServiceInterface } from '@hutsix/ngxh6';
import { CartHelpersService } from '../../../../../services/cart-helpers/cart-helpers.service';

@Component({
    selector: 'app-item-table',
    templateUrl: './item-table.component.html',
    styleUrls: ['./item-table.component.scss'],
    standalone: false,
})
export class ItemTableComponent implements CrudTableComponentInterface {
    @Input() public response: ReturnType<LineItemInterface['apiLineItemsGetCollection']>;
    @Input() public crud: CrudComponent;
    @Input() public complete: boolean;

    constructor(
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('ApiService') public api: ApiServiceInterface,
        public cartHelpers: CartHelpersService,
    ) {}
}
